/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Legal entity object
 */
export interface LegalEntity { 
    /**
     * GEWE customer \'Rechtsform\'; internal SAP ID of legal entity
     */
    legalEntityId?: string;
    /**
     * text value of legal entity
     */
    text?: string;
}

